<script>
import vueLoader from '@nulldreams/vue-loading/src/vue-loading'
export default {
  components: { vueLoader },
}
</script>

<template>
  <Transition appear>
    <vue-loader
      direction="top-right"
      image="/static/images/rotating-ring-loader.gif"
      text="Loading..."
      text-color="black"
    />
  </Transition>
</template>
